/**
 * YMM PDP Line Item Properties
 * Captures vehicle/application URL parameters from landing pages
 * and injects them as line item properties when adding to cart.
 */
(function() {
  'use strict';

  // Parse URL parameters
  function getUrlParams() {
    var params = {};
    var search = window.location.search.substring(1);
    if (!search) return params;
    
    search.split('&').forEach(function(pair) {
      var parts = pair.split('=');
      if (parts.length === 2) {
        params[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1].replace(/\+/g, ' '));
      }
    });
    return params;
  }

  // Initialize when DOM is ready
  function init() {
    var params = getUrlParams();
    var vehicle = params.vehicle;
    var application = params.application;

    // Exit if no vehicle info in URL
    if (!vehicle && !application) return;

    // Find all add-to-cart forms on the page
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    
    forms.forEach(function(form) {
      // Remove any existing YMM hidden inputs to avoid duplicates
      var existingInputs = form.querySelectorAll('input[name^="properties[Vehicle"]');
      existingInputs.forEach(function(input) { input.remove(); });
      var existingApp = form.querySelectorAll('input[name="properties[Application]"]');
      existingApp.forEach(function(input) { input.remove(); });

      // Add Vehicle property
      if (vehicle) {
        var vehicleInput = document.createElement('input');
        vehicleInput.type = 'hidden';
        vehicleInput.name = 'properties[Vehicle]';
        vehicleInput.value = vehicle;
        form.appendChild(vehicleInput);
      }

      // Add Application property
      if (application) {
        var appInput = document.createElement('input');
        appInput.type = 'hidden';
        appInput.name = 'properties[Application]';
        appInput.value = application;
        form.appendChild(appInput);
      }
    });

    // Also handle AJAX add-to-cart if theme uses it
    // Hook into Shopify's AJAX API
    if (typeof fetch !== 'undefined') {
      var originalFetch = window.fetch;
      window.fetch = function(url, options) {
        if (typeof url === 'string' && url.includes('/cart/add') && options && options.body) {
          try {
            var body;
            if (typeof options.body === 'string') {
              body = JSON.parse(options.body);
            } else if (options.body instanceof FormData) {
              // FormData - add properties directly
              if (vehicle) options.body.set('properties[Vehicle]', vehicle);
              if (application) options.body.set('properties[Application]', application);
              return originalFetch.apply(this, arguments);
            } else {
              body = options.body;
            }
            
            if (body && typeof body === 'object') {
              if (!body.properties) body.properties = {};
              if (vehicle) body.properties['Vehicle'] = vehicle;
              if (application) body.properties['Application'] = application;
              options.body = JSON.stringify(body);
            }
          } catch (e) {
            // If parsing fails, proceed with original request
          }
        }
        return originalFetch.apply(this, arguments);
      };
    }

    console.log('[YMM] Line item properties initialized:', { vehicle: vehicle, application: application });
  }

  // Run on DOMContentLoaded or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();